export default "__VITE_ASSET__Cafr9BA7__"